import React, { useState } from 'react';
import styles from './specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllVenEnquiresTable = ({data}) => {

  const navigate = useNavigate()



  return (
    <>
      <table className={styles.spectable}>
        <thead>
          <tr>
            <th>Enquiry ID</th>
            <th>Date</th>
            {/* <th>Total</th> */}
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody className={styles.spectbody}>
          {data?.map((record) => (
            <tr key={record?._id}>
              <td>#{record?._id}</td>
             <td>{formateDate(record?.createdAt)}</td>
              {/* <td>{record.total}</td> */}
              <td style={{color: record?.status == "NEW" ? '#4A4C56' : record?.status == "QUOTED" ? "#F86624" : "#1A9882"}}>{record.status}</td>
              <td className={styles.speccheck}>
                <div onClick={()=>navigate(`/vendorEnquiryDetails/${record?._id}`)} style={{color:'#885EFE',cursor:'pointer',fontWeight:500,fontSize:14}}>View Details</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AllVenEnquiresTable;